<footer class="footer">
  <div class="footer-wrapper">
    <div class="footer-links">
      <div class="row">
        <div class="col-3">
          <ul>
            <li class="footer-link-title" [innerHTML]="translate['footer.privacyCenter']"></li>
            <li>
              <a
                [routerLink]="['/'+culture+'/connected-privacy-policy']" target="_blank"
                [innerHTML]="translate['footer.connectedPrivacyPolicy']"
                (click)="trackEvent(translate['footer.privacyCenter'],translate['footer.connectedPrivacyPolicy'])"
              ></a
              >
            </li>
            <li>
              <a [href]="privacyPolicyUrl" target="_blank" [innerHTML]="translate['footer.privacyPolicy']"
                 (click)="trackEvent(translate['footer.privacyCenter'],translate['footer.privacyPolicy'])"
              ></a
              >
            </li>
            <li><a href="javascript:Optanon.ToggleInfoDisplay();" role="button"
                   [innerHTML]="translate['footer.cookies']"
                   (click)="trackEvent(translate['footer.privacyCenter'],translate['footer.cookies'])"></a></li>
          </ul>
        </div>
        <div class="col-3">
          <ul>
            <li class="footer-link-title" [innerHTML]="translate['footer.legal']"></li>
            <li>
              <a [routerLink]="['/'+culture+'/connected-terms-of-service']" target="_blank"
                 [innerHTML]="translate['footer.connectedTermsOfService']"
                 (click)="trackEvent(translate['footer.legal'],translate['footer.connectedTermsOfService'])"></a
              >
            </li>
            <li>
              <a
                [routerLink]="['/'+culture+'/website-terms-of-use']" target="_blank"
                [innerHTML]="translate['footer.websiteTermsOfUse']"
                (click)="trackEvent(translate['footer.legal'],translate['footer.websiteTermsOfUse'])"></a>
            </li>
            <li>
              <a [href]="manageYourPrivacyChoicesUrl" target="_blank"
                 [innerHTML]="translate['footer.manageYourPrivacyChoices']"
                 (click)="trackEvent(translate['footer.legal'],translate['footer.manageYourPrivacyChoices'])"></a
              >
            </li>
          </ul>
        </div>
        <div class="col-3">
          <ul>
            <li class="footer-link-title" [innerHTML]="translate['footer.support']"></li>
            <li>
              <a [routerLink]="['/'+culture+'/contact-us']" target="_blank"
                 [innerHTML]="translate['footer.contact']"
                 (click)="trackEvent(translate['footer.support'],translate['footer.contact'])"></a
              >
            </li>
            <li><a [routerLink]="['/faq']" [innerHTML]="translate['footer.faq']"
                   (click)="trackEvent(translate['footer.support'],translate['footer.faq'])"></a></li>
            <li><a [routerLink]="['/'+culture+'/plans-and-pricing']"
                   [innerHTML]="translate['footer.plansAndPricing']"
                   (click)="trackEvent(translate['footer.support'],translate['footer.plansAndPricing'])"></a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="social-bar">
      <div class="row">
        <div class="col">
          <ul>
            <li><a (click)="trackSocial('x')" [href]="twitterUrl" target="_blank"><img alt="twitterUrl" [src]="twitterIcon"/></a></li>
            <li><a (click)="trackSocial('facebook')" [href]="facebookUrl" target="_blank"><img alt="facebookUrl" [src]="facebookIcon"/></a></li>
            <li><a (click)="trackSocial('instagram')" [href]="instagramUrl" target="_blank"> <img alt="instagramUrl" [src]="instagramIcon"/></a></li>
            <li><a (click)="trackSocial('linkedin')" [href]="linkedInUrl" target="_blank"><img alt="linkedInUrl" [src]="linkedInIcon"/></a></li>
            <li><a (click)="trackSocial('youtube')" [href]="youTubeUrl" target="_blank"><img alt="youTubeUrl" [src]="youTubeIcon"/></a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</footer>
